module.exports = __webpack_public_path__ + "img/push-pin-outline.541a7d4c.svg";